export const latlong = new Map()
  .set('AD', {latitude: 42.5, longitude: 1.5})
  .set('AE', {latitude: 24, longitude: 54})
  .set('AD', {latitude: 42.5, longitude: 1.5})
  .set('AE', {latitude: 24, longitude: 54})
  .set('AF', {latitude: 33, longitude: 65})
  .set('AG', {latitude: 17.05, longitude: -61.8})
  .set('AI', {latitude: 18.25, longitude: -63.1667})
  .set('AL', {latitude: 41, longitude: 20})
  .set('AM', {latitude: 40, longitude: 45})
  .set('AN', {latitude: 12.25, longitude: -68.75})
  .set('AO', {latitude: -12.5, longitude: 18.5})
  .set('AP', {latitude: 35, longitude: 105})
  .set('AQ', {latitude: -90, longitude: 0})
  .set('AR', {latitude: -34, longitude: -64})
  .set('AS', {latitude: -14.3333, longitude: -170})
  .set('AT', {latitude: 47.3333, longitude: 13.3333})
  .set('AU', {latitude: -27, longitude: 133})
  .set('AW', {latitude: 12.5, longitude: -69.9667})
  .set('AZ', {latitude: 40.5, longitude: 47.5})
  .set('BA', {latitude: 44, longitude: 18})
  .set('BB', {latitude: 13.1667, longitude: -59.5333})
  .set('BD', {latitude: 24, longitude: 90})
  .set('BE', {latitude: 50.8333, longitude: 4})
  .set('BF', {latitude: 13, longitude: -2})
  .set('BG', {latitude: 43, longitude: 25})
  .set('BH', {latitude: 26, longitude: 50.55})
  .set('BI', {latitude: -3.5, longitude: 30})
  .set('BJ', {latitude: 9.5, longitude: 2.25})
  .set('BM', {latitude: 32.3333, longitude: -64.75})
  .set('BN', {latitude: 4.5, longitude: 114.6667})
  .set('BO', {latitude: -17, longitude: -65})
  .set('BR', {latitude: -10, longitude: -55})
  .set('BS', {latitude: 24.25, longitude: -76})
  .set('BT', {latitude: 27.5, longitude: 90.5})
  .set('BV', {latitude: -54.4333, longitude: 3.4})
  .set('BW', {latitude: -22, longitude: 24})
  .set('BY', {latitude: 53, longitude: 28})
  .set('BZ', {latitude: 17.25, longitude: -88.75})
  .set('CA', {latitude: 54, longitude: -100})
  .set('CC', {latitude: -12.5, longitude: 96.8333})
  .set('CD', {latitude: 0, longitude: 25})
  .set('CF', {latitude: 7, longitude: 21})
  .set('CG', {latitude: -1, longitude: 15})
  .set('CH', {latitude: 47, longitude: 8})
  .set('CI', {latitude: 8, longitude: -5})
  .set('CK', {latitude: -21.2333, longitude: -159.7667})
  .set('CL', {latitude: -30, longitude: -71})
  .set('CM', {latitude: 6, longitude: 12})
  .set('CN', {latitude: 35, longitude: 105})
  .set('CO', {latitude: 4, longitude: -72})
  .set('CR', {latitude: 10, longitude: -84})
  .set('CU', {latitude: 21.5, longitude: -80})
  .set('CV', {latitude: 16, longitude: -24})
  .set('CX', {latitude: -10.5, longitude: 105.6667})
  .set('CY', {latitude: 35, longitude: 33})
  .set('CZ', {latitude: 49.75, longitude: 15.5})
  .set('DE', {latitude: 51, longitude: 9})
  .set('DJ', {latitude: 11.5, longitude: 43})
  .set('DK', {latitude: 56, longitude: 10})
  .set('DM', {latitude: 15.4167, longitude: -61.3333})
  .set('DO', {latitude: 19, longitude: -70.6667})
  .set('DZ', {latitude: 28, longitude: 3})
  .set('EC', {latitude: -2, longitude: -77.5})
  .set('EE', {latitude: 59, longitude: 26})
  .set('EG', {latitude: 27, longitude: 30})
  .set('EH', {latitude: 24.5, longitude: -13})
  .set('ER', {latitude: 15, longitude: 39})
  .set('ES', {latitude: 40, longitude: -4})
  .set('ET', {latitude: 8, longitude: 38})
  .set('EU', {latitude: 47, longitude: 8})
  .set('FI', {latitude: 62, longitude: 26})
  .set('FJ', {latitude: -18, longitude: 175})
  .set('FK', {latitude: -51.75, longitude: -59})
  .set('FM', {latitude: 6.9167, longitude: 158.25})
  .set('FO', {latitude: 62, longitude: -7})
  .set('FR', {latitude: 46, longitude: 2})
  .set('GA', {latitude: -1, longitude: 11.75})
  .set('GB', {latitude: 54, longitude: -2})
  .set('GD', {latitude: 12.1167, longitude: -61.6667})
  .set('GE', {latitude: 42, longitude: 43.5})
  .set('GF', {latitude: 4, longitude: -53})
  .set('GH', {latitude: 8, longitude: -2})
  .set('GI', {latitude: 36.1833, longitude: -5.3667})
  .set('GL', {latitude: 72, longitude: -40})
  .set('GM', {latitude: 13.4667, longitude: -16.5667})
  .set('GN', {latitude: 11, longitude: -10})
  .set('GP', {latitude: 16.25, longitude: -61.5833})
  .set('GQ', {latitude: 2, longitude: 10})
  .set('GR', {latitude: 39, longitude: 22})
  .set('GS', {latitude: -54.5, longitude: -37})
  .set('GT', {latitude: 15.5, longitude: -90.25})
  .set('GU', {latitude: 13.4667, longitude: 144.7833})
  .set('GW', {latitude: 12, longitude: -15})
  .set('GY', {latitude: 5, longitude: -59})
  .set('HK', {latitude: 22.25, longitude: 114.1667})
  .set('HM', {latitude: -53.1, longitude: 72.5167})
  .set('HN', {latitude: 15, longitude: -86.5})
  .set('HR', {latitude: 45.1667, longitude: 15.5})
  .set('HT', {latitude: 19, longitude: -72.4167})
  .set('HU', {latitude: 47, longitude: 20})
  .set('ID', {latitude: -5, longitude: 120})
  .set('IE', {latitude: 53, longitude: -8})
  .set('IL', {latitude: 31.5, longitude: 34.75})
  .set('IN', {latitude: 20, longitude: 77})
  .set('IO', {latitude: -6, longitude: 71.5})
  .set('IQ', {latitude: 33, longitude: 44})
  .set('IR', {latitude: 32, longitude: 53})
  .set('IS', {latitude: 65, longitude: -18})
  .set('IT', {latitude: 42.8333, longitude: 12.8333})
  .set('JM', {latitude: 18.25, longitude: -77.5})
  .set('JO', {latitude: 31, longitude: 36})
  .set('JP', {latitude: 36, longitude: 138})
  .set('KE', {latitude: 1, longitude: 38})
  .set('KG', {latitude: 41, longitude: 75})
  .set('KH', {latitude: 13, longitude: 105})
  .set('KI', {latitude: 1.4167, longitude: 173})
  .set('KM', {latitude: -12.1667, longitude: 44.25})
  .set('KN', {latitude: 17.3333, longitude: -62.75})
  .set('KP', {latitude: 40, longitude: 127})
  .set('KR', {latitude: 37, longitude: 127.5})
  .set('KW', {latitude: 29.3375, longitude: 47.6581})
  .set('KY', {latitude: 19.5, longitude: -80.5})
  .set('KZ', {latitude: 48, longitude: 68})
  .set('LA', {latitude: 18, longitude: 105})
  .set('LB', {latitude: 33.8333, longitude: 35.8333})
  .set('LC', {latitude: 13.8833, longitude: -61.1333})
  .set('LI', {latitude: 47.1667, longitude: 9.5333})
  .set('LK', {latitude: 7, longitude: 81})
  .set('LR', {latitude: 6.5, longitude: -9.5})
  .set('LS', {latitude: -29.5, longitude: 28.5})
  .set('LT', {latitude: 55, longitude: 24})
  .set('LU', {latitude: 49.75, longitude: 6})
  .set('LV', {latitude: 57, longitude: 25})
  .set('LY', {latitude: 25, longitude: 17})
  .set('MA', {latitude: 32, longitude: -5})
  .set('MC', {latitude: 43.7333, longitude: 7.4})
  .set('MD', {latitude: 47, longitude: 29})
  .set('ME', {latitude: 42.5, longitude: 19.4})
  .set('MG', {latitude: -20, longitude: 47})
  .set('MH', {latitude: 9, longitude: 168})
  .set('MK', {latitude: 41.8333, longitude: 22})
  .set('ML', {latitude: 17, longitude: -4})
  .set('MM', {latitude: 22, longitude: 98})
  .set('MN', {latitude: 46, longitude: 105})
  .set('MO', {latitude: 22.1667, longitude: 113.55})
  .set('MP', {latitude: 15.2, longitude: 145.75})
  .set('MQ', {latitude: 14.6667, longitude: -61})
  .set('MR', {latitude: 20, longitude: -12})
  .set('MS', {latitude: 16.75, longitude: -62.2})
  .set('MT', {latitude: 35.8333, longitude: 14.5833})
  .set('MU', {latitude: -20.2833, longitude: 57.55})
  .set('MV', {latitude: 3.25, longitude: 73})
  .set('MW', {latitude: -13.5, longitude: 34})
  .set('MX', {latitude: 23, longitude: -102})
  .set('MY', {latitude: 2.5, longitude: 112.5})
  .set('MZ', {latitude: -18.25, longitude: 35})
  .set('NA', {latitude: -22, longitude: 17})
  .set('NC', {latitude: -21.5, longitude: 165.5})
  .set('NE', {latitude: 16, longitude: 8})
  .set('NF', {latitude: -29.0333, longitude: 167.95})
  .set('NG', {latitude: 10, longitude: 8})
  .set('NI', {latitude: 13, longitude: -85})
  .set('NL', {latitude: 52.5, longitude: 5.75})
  .set('NO', {latitude: 62, longitude: 10})
  .set('NP', {latitude: 28, longitude: 84})
  .set('NR', {latitude: -0.5333, longitude: 166.9167})
  .set('NU', {latitude: -19.0333, longitude: -169.8667})
  .set('NZ', {latitude: -41, longitude: 174})
  .set('OM', {latitude: 21, longitude: 57})
  .set('PA', {latitude: 9, longitude: -80})
  .set('PE', {latitude: -10, longitude: -76})
  .set('PF', {latitude: -15, longitude: -140})
  .set('PG', {latitude: -6, longitude: 147})
  .set('PH', {latitude: 13, longitude: 122})
  .set('PK', {latitude: 30, longitude: 70})
  .set('PL', {latitude: 52, longitude: 20})
  .set('PM', {latitude: 46.8333, longitude: -56.3333})
  .set('PR', {latitude: 18.25, longitude: -66.5})
  .set('PS', {latitude: 32, longitude: 35.25})
  .set('PT', {latitude: 39.5, longitude: -8})
  .set('PW', {latitude: 7.5, longitude: 134.5})
  .set('PY', {latitude: -23, longitude: -58})
  .set('QA', {latitude: 25.5, longitude: 51.25})
  .set('RE', {latitude: -21.1, longitude: 55.6})
  .set('RO', {latitude: 46, longitude: 25})
  .set('RS', {latitude: 44, longitude: 21})
  // .set('RU', {latitude: 60, longitude: 100})
  .set('RU', {latitude: 55, longitude: 40})
  .set('RW', {latitude: -2, longitude: 30})
  .set('SA', {latitude: 25, longitude: 45})
  .set('SB', {latitude: -8, longitude: 159})
  .set('SC', {latitude: -4.5833, longitude: 55.6667})
  .set('SD', {latitude: 15, longitude: 30})
  .set('SE', {latitude: 62, longitude: 15})
  .set('SG', {latitude: 1.3667, longitude: 103.8})
  .set('SH', {latitude: -15.9333, longitude: -5.7})
  .set('SI', {latitude: 46, longitude: 15})
  .set('SJ', {latitude: 78, longitude: 20})
  .set('SK', {latitude: 48.6667, longitude: 19.5})
  .set('SL', {latitude: 8.5, longitude: -11.5})
  .set('SM', {latitude: 43.7667, longitude: 12.4167})
  .set('SN', {latitude: 14, longitude: -14})
  .set('SO', {latitude: 10, longitude: 49})
  .set('SR', {latitude: 4, longitude: -56})
  .set('ST', {latitude: 1, longitude: 7})
  .set('SV', {latitude: 13.8333, longitude: -88.9167})
  .set('SY', {latitude: 35, longitude: 38})
  .set('SZ', {latitude: -26.5, longitude: 31.5})
  .set('TC', {latitude: 21.75, longitude: -71.5833})
  .set('TD', {latitude: 15, longitude: 19})
  .set('TF', {latitude: -43, longitude: 67})
  .set('TG', {latitude: 8, longitude: 1.1667})
  .set('TH', {latitude: 15, longitude: 100})
  .set('TJ', {latitude: 39, longitude: 71})
  .set('TK', {latitude: -9, longitude: -172})
  .set('TM', {latitude: 40, longitude: 60})
  .set('TN', {latitude: 34, longitude: 9})
  .set('TO', {latitude: -20, longitude: -175})
  .set('TR', {latitude: 39, longitude: 35})
  .set('TT', {latitude: 11, longitude: -61})
  .set('TV', {latitude: -8, longitude: 178})
  .set('TW', {latitude: 23.5, longitude: 121})
  .set('TZ', {latitude: -6, longitude: 35})
  .set('UA', {latitude: 49, longitude: 32})
  .set('UG', {latitude: 1, longitude: 32})
  .set('UM', {latitude: 19.2833, longitude: 166.6})
  .set('US', {latitude: 38, longitude: -97})
  .set('UY', {latitude: -33, longitude: -56})
  .set('UZ', {latitude: 41, longitude: 64})
  .set('VA', {latitude: 41.9, longitude: 12.45})
  .set('VC', {latitude: 13.25, longitude: -61.2})
  .set('VE', {latitude: 8, longitude: -66})
  .set('VG', {latitude: 18.5, longitude: -64.5})
  .set('VI', {latitude: 18.3333, longitude: -64.8333})
  .set('VN', {latitude: 16, longitude: 106})
  .set('VU', {latitude: -16, longitude: 167})
  .set('WF', {latitude: -13.3, longitude: -176.2})
  .set('WS', {latitude: -13.5833, longitude: -172.3333})
  .set('YE', {latitude: 15, longitude: 48})
  .set('YT', {latitude: -12.8333, longitude: 45.1667})
  .set('ZA', {latitude: -29, longitude: 24})
  .set('ZM', {latitude: -15, longitude: 30})
  .set('ZW', {latitude: -20, longitude: 30});
